const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaTipo: [],
    listaMotorista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'FEEDBACK_MOTORISTA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'FEEDBACK_MOTORISTA_LISTADO':
            return {
                ...state,
                lista: action.payload.data
            };
           
        case 'FEEDBACK_MOTORISTA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
            };

        case 'FEEDBACK_MOTORISTA_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };
            
        default:
            return state;
    }
}
